import { SORT_CONDITIONS_ORDER, SORT_TYPE, SORT_TYPE_COMBI, SORT_TYPE_NAME } from '../../../Common';
import { CustomerInfoListSortCondition } from './interfaces';

// 定数定義

/**
 * 1ページあたりの表示件数
 */
export const maxItemPerPage = 10;

/**
 * カレントページの前後に表示するページ数の上限値
 */
export const showItemsMaxCountAroundCurrentPage = 2;

/**
 * 並び順プルダウン定義
 */
export const sortConditions: CustomerInfoListSortCondition[] = SORT_CONDITIONS_ORDER.map((sortKey) => ({
  key: SORT_TYPE[sortKey as keyof typeof SORT_TYPE],
  label: SORT_TYPE_NAME[sortKey as keyof typeof SORT_TYPE_NAME],
  col: SORT_TYPE_COMBI[sortKey as keyof typeof SORT_TYPE_COMBI].col,
  order: SORT_TYPE_COMBI[sortKey as keyof typeof SORT_TYPE_COMBI].order,
}));
